import script from "./TraitShopSort.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopSort.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopSort.vue?vue&type=style&index=0&id=55c751ad&lang=scss"

const __exports__ = script;

export default __exports__